import { useState } from "react";
import { Link } from "react-router";
import { Facebook, Twitter, Linkedin, Instagram, ArrowUpRight, Mail, Phone, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { LegalModal } from "./LegalModal";

export function Footer() {
  const [activeLegalModal, setActiveLegalModal] = useState<"privacy" | "terms" | null>(null);

  return (
    <>
      <footer className="bg-slate-900 text-slate-300 py-12 md:py-16">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12 mb-12">
            <div className="space-y-6">
              <Link to="/" className="flex items-center gap-2 text-white">
                <Logo className="h-16 w-auto" />
              </Link>
              <p className="text-sm leading-relaxed text-slate-400">
                Transforming businesses through premium IT services, strategic consulting, and cutting-edge product development.
              </p>
              <div className="flex gap-4">
                <SocialIcon icon={<Linkedin size={18} />} />
                <SocialIcon icon={<Twitter size={18} />} />
                <SocialIcon icon={<Facebook size={18} />} />
                <SocialIcon icon={<Instagram size={18} />} />
              </div>
            </div>

            <div>
              <h4 className="text-white font-semibold mb-6">Services</h4>
              <ul className="space-y-4 text-sm">
                <li><Link to="/services" className="hover:text-[#FD5750] transition-colors">Web Development</Link></li>
                <li><Link to="/services" className="hover:text-[#FD5750] transition-colors">App Development</Link></li>
                <li><Link to="/services" className="hover:text-[#FD5750] transition-colors">UX/UI Design</Link></li>
                <li><Link to="/services" className="hover:text-[#FD5750] transition-colors">Cyber Security</Link></li>
                <li><Link to="/services" className="hover:text-[#FD5750] transition-colors">Strategy Consulting</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold mb-6">Company</h4>
              <ul className="space-y-4 text-sm">
                <li><Link to="/about" className="hover:text-[#FD5750] transition-colors">About Us</Link></li>
                <li><Link to="/articles" className="hover:text-[#FD5750] transition-colors">Articles</Link></li>
                <li><Link to="/industries" className="hover:text-[#FD5750] transition-colors">Industries</Link></li>
                <li><Link to="/careers" className="hover:text-[#FD5750] transition-colors">Careers</Link></li>
                <li><Link to="/contact" className="hover:text-[#FD5750] transition-colors">Contact</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold mb-6">Get in Touch</h4>
              <ul className="space-y-4 text-sm">
                <li className="flex items-start gap-3">
                  <span className="text-[#FD5750] mt-0.5 shrink-0"><Mail size={18} /></span>
                  <a href="mailto:hello@intelisine.com" className="hover:text-white">hello@intelisine.com</a>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#FD5750] mt-0.5 shrink-0"><Phone size={18} /></span>
                  <a href="tel:+916383250771" className="hover:text-white">+91 63832 50771</a>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#FD5750] mt-0.5 shrink-0"><MapPin size={18} /></span>
                  <span>No. 8, B6, Sri Krishna Flats, <br />10th Street, Nanganallur, Chennai-600061, <br /> Tamil Nadu, India</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500">
            <p>&copy; {new Date().getFullYear()} Intelisine. All rights reserved.</p>
            <div className="flex gap-8">
              <button 
                onClick={() => setActiveLegalModal("privacy")}
                className="hover:text-white transition-colors cursor-pointer"
              >
                Privacy Policy
              </button>
              <button 
                onClick={() => setActiveLegalModal("terms")}
                className="hover:text-white transition-colors cursor-pointer"
              >
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </footer>
      
      <LegalModal 
        isOpen={!!activeLegalModal} 
        onClose={() => setActiveLegalModal(null)} 
        type={activeLegalModal || "privacy"} 
      />
    </>
  );
}

function SocialIcon({ icon }: { icon: React.ReactNode }) {
  return (
    <a
      href="#"
      className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-[#FD5750] hover:text-white transition-all duration-300"
    >
      {icon}
    </a>
  );
}
